module.exports = __webpack_public_path__ + "assets/img/sm1.1331bf38.png";